import React from 'react';
import { useTheme } from 'styled-components';
import { Padlock, Home } from "../Icon";
import BackgroundProvider from "../BackgroundProvider";
import Text from "../Text";
import { StyledAuthHeaderMobileButtonsContainer, StyledAuthHeaderMobileButton } from "./styled";
var AuthMobileButtons = function AuthMobileButtons(_ref) {
  var _ref$homeButton = _ref.homeButton,
    homeButton = _ref$homeButton === void 0 ? false : _ref$homeButton,
    _ref$onHomeClick = _ref.onHomeClick,
    onHomeClick = _ref$onHomeClick === void 0 ? function () {} : _ref$onHomeClick,
    _ref$onLogoutClick = _ref.onLogoutClick,
    onLogoutClick = _ref$onLogoutClick === void 0 ? function () {} : _ref$onLogoutClick;
  var theme = useTheme() || {};
  return /*#__PURE__*/React.createElement(StyledAuthHeaderMobileButtonsContainer, {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.header_color_background
    }
  }, /*#__PURE__*/React.createElement(StyledAuthHeaderMobileButton, {
    onClick: onLogoutClick,
    onKeyPress: onLogoutClick
  }, /*#__PURE__*/React.createElement(Padlock, {
    color: "inherit",
    iconSize: "lg",
    size: "s2"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: "s1",
    weight: theme.button_config_font_weight
  }, theme.header_config_logout_text || 'Log off')), homeButton && /*#__PURE__*/React.createElement(StyledAuthHeaderMobileButton, {
    onClick: onHomeClick,
    onKeyPress: onHomeClick
  }, /*#__PURE__*/React.createElement(Home, {
    color: "inherit",
    iconSize: "lg",
    size: "s2"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: "s1",
    weight: theme.button_config_font_weight
  }, "Home"))));
};
AuthMobileButtons.displayName = 'AuthMobileButtons';
export default AuthMobileButtons;